import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=43f64ef0"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"
import style0 from "./pagination.vue?vue&type=style&index=0&id=43f64ef0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconChevronLeft: require('/vercel/path0/components/ui/icon/chevron-left.vue').default,UiIconChevronRight: require('/vercel/path0/components/ui/icon/chevron-right.vue').default})
